import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41z"
}), 'CallReceivedSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallReceivedSharp.js
// module id = 2618
// module chunks = 2